export default __webpack_public_path__ + "static/media/ic_info_warning.4ba4a9e8.svg";